// extracted by mini-css-extract-plugin
export default {"embed-form":"Z9WsXs","embedForm":"Z9WsXs","size-picker":"Oyw91C","sizePicker":"Oyw91C"};